/**
 * Case Form Field entity
 * Represents a field within a case form
 */
export class CaseFormFieldEntity {
  public id!: string;
  public name!: string;
  public label!: string;
  public helperText?: string;
  public placeholder?: string;
  public fieldType!: CaseFormFieldType;
  public isRequired!: boolean;
  public isVisibleToRequester?: boolean;
  public isHiddenByDefault?: boolean;
  public isSystem!: boolean;
  public sensitivityCategory?: string | null;
  public visibilityRule?: CaseFormFieldVisibilityRule | null;
  public sortOrder!: number;
  public options?: string[];
  public defaultValue?: string;
  public validationRules?: Record<string, unknown>;
  public constraints?: CaseFormFieldConstraint[];
}

/**
 * Case Form Field Visibility Rule
 * Represents conditional visibility for a field
 */
export interface CaseFormFieldVisibilityRule {
  sourceFieldId: string;
  operator: string;
  value: string;
  show: boolean;
}

/**
 * Case Form Field Constraint
 * Represents a constraint on a field (e.g., maxLength, options, etc.)
 */
export interface CaseFormFieldConstraint {
  typeConstraintId: string;
  constraintKey: string;
  value: string;
  label: string;
  valueType: string;
  defaultValue: string | null;
}

/**
 * Available field types for case forms
 */
export type CaseFormFieldType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'email'
  | 'date'
  | 'select'
  | 'checkbox'
  | 'checkboxes'
  | 'radio'
  | 'radio_buttons'
  | 'file'
  | 'file_upload'
  | 'currency'
  | 'time'
  | 'yes_no';
